import type { RutaProd } from '../../../../runtime/rutas';
export default {
  ruta: '/sistema/reportesbi/envios',
  documento: 'reportesbi',
  acceso: 'sesion',
  filas: ['119'],
  cita: 'Areas/ReportesBI/Controllers/EnviosController.cs:55',
} satisfies RutaProd;
